import React,{useEffect, useState} from "react";
import "../../scss/main.scss";
import "../../scss/bootstrap.scss";
import { IoMenu } from "react-icons/io5";
import HeroImage from "../../images/homePage/heroIMG.png";
import Avatar1 from "../../images/homePage/avatar-1.webp";
import Avatar2 from "../../images/homePage/avatar-2.webp";
import Avatar3 from "../../images/homePage/avatar-3.webp";
import Avatar4 from "../../images/homePage/avatar-4.webp";
import Avatar5 from "../../images/homePage/avatar-5.webp";
import About1 from "../../images/homePage/about-2.webp";
import About2 from "../../images/homePage/about-5.webp";
import FeatureImg from "../../images/homePage/features-illustration-3.webp";
import AddionalFeatureImg from "../../images/homePage/phone-app-screen.png";
import refoDashboard from "../../images/homePage/refoDashboard.jpg";
import refoLogo from "../../images/homePage/refo.png";
import { IoCloseSharp } from "react-icons/io5";
import { FiPhone } from "react-icons/fi";
import { IoMailOutline } from "react-icons/io5";
import { IoShieldCheckmarkOutline } from "react-icons/io5";

import { TfiStatsUp } from "react-icons/tfi";
import { RiPassValidLine } from "react-icons/ri";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import Feature1 from "../../images/homePage/featuresIcons/1.png";
import Feature2 from "../../images/homePage/featuresIcons/2.png";
import Feature3 from "../../images/homePage/featuresIcons/3.png";
import Feature4 from "../../images/homePage/featuresIcons/4.png";
import Feature5 from "../../images/homePage/featuresIcons/5.png";
import Feature6 from "../../images/homePage/featuresIcons/6.png";
import Feature7 from "../../images/homePage/featuresIcons/7.png";
import { useNotification } from "../../hooks/useNotification";
import axios from "axios";
import { Link, Events, animateScroll as scroll, scrollSpy } from "react-scroll";
import {Link as ReactDomLink} from "react-router-dom"
import { LiaCheckDoubleSolid } from "react-icons/lia";
import { IoClose } from "react-icons/io5";
import { ToastContainer } from "react-toastify";
import { isAuthenticatedFun } from "../../utils/constant";
import { useHistory } from "react-router-dom";

const HomePage = () => {

  const history = useHistory();
  const handleNotificationCall = useNotification();
  const validationSchema = Yup.object().shape({
    companyName: Yup.string()
      .max(255)
      .required("Name of the your company is required"),
    mobile: Yup.string()
      .required("Mobile Number is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    email: Yup.string()
      .required("Email ID is required")
      .email("Email must be a Valid Email Address"),
    countries: Yup.string(),
    message: Yup.string(),
  });

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  async function handleDemoSubmit(value) {
    
    try {
      // Prepare the payload
      const data = value;
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}auth/contactSales`,
        
          data,
        
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
      
        reset();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error("Error submitting leave details:", error);
    }
  }

  useEffect(() => {
    
    Events.scrollEvent.register('begin', (to, element) => {
      console.log('begin', to, element);
    });

    Events.scrollEvent.register('end', (to, element) => {
      console.log('end', to, element);
    });

    scrollSpy.update();

    return () => {
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
    };
  }, []);

  useEffect(()=>{
    if (isAuthenticatedFun()) {
      history.push("/app"); // Redirect to /app if already logged in
    }
  },[])

  const [menuBar ,setMenuBar]=useState(false);

  if(menuBar){
    document.body.classList.add("mobile-nav-active");
  }else{
    document.body.classList.remove("mobile-nav-active");
  }

  return (
    <>
      <header
        id="header"
        className="header d-flex align-items-center fixed-top"
      >
        <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
        <Link
                  to="hero"
                  style={{cursor:"pointer"}}
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={0}
               
            className="logo d-flex align-items-center me-auto me-xl-0"
          >
          
            <div className="sitename">
              <img src={refoLogo} alt="refo-logo" height={25} />
            </div>
          </Link>

          <nav id="navmenu" className="navmenu">
            <ul>
              <li>
                <Link
                  to="hero"
                  style={{cursor:"pointer"}}
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={0}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="why-refo"
                  spy={true}
                  smooth={true}
                  style={{cursor:"pointer"}}
                  duration={500}
                  offset={-30}
                >
                  Why refo
                </Link>
              </li>
              <li>
                <Link
                  to="features"
                  spy={true}
                  smooth={true}
                  style={{cursor:"pointer"}}
                  offset={-100}
                  duration={500}
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  style={{cursor:"pointer"}}
                  offset={-120}
                  duration={500}
                >
                  Contact
                </Link>
              </li>
             
            </ul>
          
            <div className="mobile-nav-toggle d-xl-none" onClick={()=>setMenuBar(prev=>!prev)}>
            {menuBar ? <IoClose/> :  <IoMenu />}
                
            </div>
          </nav>

          <ReactDomLink to="/Login" className="btn-getstarted text-light" >
            Login
          </ReactDomLink>
        </div>
      </header>

      <main className="main">
        <section id="hero" className="hero section">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div
                  className="hero-content"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="company-badge mb-4">
                    <i className="bi bi-gear-fill me-2"></i>
                    Your ultimate partner in building better teams
                  </div>

                  <h1 className="mb-4">
                  Transform Your HR Management 
                  {/* with&nbsp;<span className="accent-text" style={{color:"#064be2"}}>refo</span> */}
                  </h1>

                  <p className="mb-4 mb-md-5">
                  refo simplifies HR operations and hiring with a powerful combination of HRMS and ATS features—streamline workflows, track candidates, and manage your team efficiently, all in one place.
                  </p>

                  <div className="hero-buttons">
                  <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  style={{cursor:"pointer"}}
                  offset={-120}
                  duration={500}
                  className="btn btn-primary me-0 me-sm-2 mx-1"
                >
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div
                  className="hero-image"
                  data-aos="zoom-out"
                  data-aos-delay="300"
                >
                  <img src={HeroImage} alt="Hero Image" className="img-fluid" />

                  <div className="customers-badge  d-none">
                    <div className="customer-avatars">
                      <img src={Avatar1} alt="Customer 1" className="avatar" />
                      <img src={Avatar2} alt="Customer 2" className="avatar" />
                      <img src={Avatar3} alt="Customer 3" className="avatar" />
                      <img src={Avatar4} alt="Customer 4" className="avatar" />
                      <img src={Avatar5} alt="Customer 5" className="avatar" />
                      <span className="avatar more">12+</span>
                    </div>
                    <p className="mb-0 mt-2">
                      12,000+ lorem ipsum dolor sit amet consectetur adipiscing
                      elit
                    </p>
                  </div>
                </div>
              </div>
            </div>

      
          </div>
        </section>

        {/* About */}
        <section id="why-refo" className="about section">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row gy-4 align-items-center justify-content-between">
              <div className="col-xl-5" data-aos="fade-up" data-aos-delay="200">
                <span className="about-meta">MORE ABOUT US</span>
                <h2 className="about-title">
                Why refo Stands Out
                </h2>
                <p className="about-description">
                Discover how Refo transforms HR management and recruitment with simplicity, innovation, and results.
                </p>

                <div className="row feature-list-wrapper">
                  <div className="col-md-6">
                    <ul className="feature-list">
                      <li>
                      <LiaCheckDoubleSolid color="green" size={20} />{" "} Streamlined HR Processes
                      </li>
                      <li>
                      <LiaCheckDoubleSolid color="green" size={20} />{" "} Smart Recruitment Tools
                      </li>
                      <li>
                      <LiaCheckDoubleSolid color="green" size={20} />{" "} Customizable to Your Needs
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="feature-list">
                      <li>
                      <LiaCheckDoubleSolid color="green" size={20} />{" "} Accessible Anytime, Anywhere
                      </li>
                      <li>
                      <LiaCheckDoubleSolid color="green" size={20} />{" "} Data-Driven Decisions
                      </li>
                  
                    </ul>
                  </div>
                </div>

                <p className="about-description">
                refo is your all-in-one solution for managing your workforce and recruitment like never before.
                </p>
                {/* <div className="info-wrapper">
                  <div className="row gy-4">
                    <div className="col-lg-5">
                      <div className="profile d-flex align-items-center gap-3">
                        <img
                          src="assets/img/avatar-1.webp"
                          alt="CEO Profile"
                          className="profile-image"
                        />
                        <div>
                          <h4 className="profile-name">Mario Smith</h4>
                          <p className="profile-position">CEO &amp; Founder</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7">
                      <div className="contact-info d-flex align-items-center gap-2">
                        <i className="bi bi-telephone-fill"></i>
                        <div>
                          <p className="contact-label">Call us anytime</p>
                          <p className="contact-number">+123 456-789</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="col-xl-6" data-aos="fade-up" data-aos-delay="300">
                <div className="image-wrapper">
                  <div
                    className="images position-relative"
                    data-aos="zoom-out"
                    data-aos-delay="400"
                  >
                    <img
                      src={About2}
                      alt="Business Meeting"
                      className="img-fluid main-image rounded-4"
                    />
                    <img
                      src={About1}
                      alt="Team Discussion"
                      className="img-fluid small-image rounded-4"
                    />
                  </div>
                  {/* <div className="experience-badge floating">
                    <h3>
                      15+ <span>Years</span>
                    </h3>
                    <p>Of experience in business service</p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>

          {/* Addional Features */}

          <section id="features" className="features-2 section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Features</h2>
          </div>
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row align-items-center">
              <div className="col-lg-4">
                <div
                  className="feature-item text-end mb-5 pb-lg-5"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <div className="d-flex lg:flex-row-reverse align-items-center justify-content-end gap-4">
                  <div className="feature-icon flex-shrink-0">
                      <img src={Feature1} alt="Feature Icon 1" />
                    </div>
                    <div className="feature-content">
                      <h3>Centralized Management</h3>
                      <p>
                        A single dashboard provides oversight for all job
                        activities, making it easier to manage and monitor
                        processes.​
                      </p>
                    </div>
                
                  </div>
                </div>

                <div
                  className="feature-item text-end mb-5 pb-lg-5"
                  data-aos="fade-right"
                  data-aos-delay="300"
                >
                  <div className="d-flex lg:flex-row-reverse align-items-center justify-content-end gap-4">
                  <div className="feature-icon flex-shrink-0">
                      <img src={Feature2} alt="Feature Icon 1" />
                    </div>
                    <div className="feature-content">
                      <h3>User Role Allocation</h3>
                      <p>
                        Differentiates between internal employees and vendors,
                        ensuring that job visibility and allocation
                        responsibilities are clearly defined.​
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="feature-item text-end pb-lg-5"
                  data-aos="fade-right"
                  data-aos-delay="400"
                >
                  <div className="d-flex lg:flex-row-reverse align-items-center justify-content-end gap-4">
                    
                  <div className="feature-icon flex-shrink-0">
                      <img src={Feature3} alt="Feature Icon 1" />
                    </div>
                    <div className="feature-content">
                      <h3>Structured Project Management</h3>
                      <p>
                        The ability to create projects and requirements adds
                        structure to recruitment, avoiding ad-hoc hiring
                        practices.​
                      </p>
                    </div>
                  
                  </div>
                </div>
              </div>

              <div className="col-lg-4" data-aos="zoom-in" data-aos-delay="200">
                <div className="phone-mockup text-center pb-lg-5">
                  <img
                    src={AddionalFeatureImg}
                    alt="Phone Mockup"
                    className="img-fluid"
                  />
                </div>
                <div
                  className="feature-item mb-5"
                  data-aos="fade-left"
                  data-aos-delay="200"
                >
                  <div className="d-flex align-items-center gap-4">
                    <div className="feature-icon flex-shrink-0">
                      <img src={Feature7} alt="Feature Icon 1" />
                    </div>
                    <div className="feature-content">
                      <h3>Customization and Control</h3>
                      <p>
                        Settings provide flexibility for configuring the system
                        according to business needs. ​
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div
                  className="feature-item mb-5 pb-lg-5"
                  data-aos="fade-left"
                  data-aos-delay="200"
                >
                  <div className="d-flex align-items-center gap-4">
                    <div className="feature-icon flex-shrink-0">
                      <img src={Feature4} alt="Feature Icon 1" />
                    </div>
                    <div className="feature-content">
                      <h3>Candidate Tracking</h3>
                      <p>
                        By adding candidates to specific requirements, there’s a
                        streamlined approach to matching talent with job
                        openings.​
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="feature-item mb-5  pb-lg-5"
                  data-aos="fade-left"
                  data-aos-delay="300"
                >
                  <div className="d-flex align-items-center gap-4">
                    <div className="feature-icon flex-shrink-0">
                      <img src={Feature5} alt="Feature Icon 1" />
                    </div>
                    <div className="feature-content">
                      <h3>Efficient Talent Search</h3>
                      <p>
                        A dedicated step for searching candidates addresses the
                        challenge of sifting through large talent pools.​
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="feature-item"
                  data-aos="fade-left"
                  data-aos-delay="400"
                >
                  <div className="d-flex align-items-center pb-lg-5 gap-4">
                    <div className="feature-icon flex-shrink-0">
                      <div className="feature-icon flex-shrink-0">
                        <img src={Feature6} alt="Feature Icon 1" />
                      </div>
                    </div>
                    <div className="feature-content">
                      <h3>Data-Driven Insights</h3>
                      <p>
                        Report generation allows for performance tracking and
                        informed decision-making.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features */}

        <section id="features-2" className="features section">
          <div className="container section-title pb-0" data-aos="fade-up">
            <h2>Additional Features</h2>
          </div>

          <div className="container">
            {/* <div className="d-flex justify-content-center">

          <ul className="nav nav-tabs" data-aos="fade-up" data-aos-delay="100">

            <li className="nav-item">
              <a className="nav-link active show" data-bs-toggle="tab" data-bs-target="#features-tab-1">
                <h4>Modisit</h4>
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" data-bs-target="#features-tab-2">
                <h4>Praesenti</h4>
              </a>

            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" data-bs-target="#features-tab-3">
                <h4>Explica</h4>
              </a>
            </li>

          </ul>

        </div> */}

            <div
              className="tab-content"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="tab-pane fade active show" id="features-tab-1">
                <div className="row">
                  <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                    <h3>Explore Even More Features</h3>
                    <p className="fst-italic">
                    refo takes your HR management to the next level with these additional tools designed to simplify your workflow and enhance productivity.
                    </p>
                    <ul>
                      <li>
                        <LiaCheckDoubleSolid color="green" size={20} />{" "}
                        <span>Employee Management​</span>
                      </li>
                      <li>
                        <LiaCheckDoubleSolid color="green" size={20} />{" "}
                        <span>Payroll & Compensation​</span>
                      </li>
                      <li>
                        <LiaCheckDoubleSolid color="green" size={20} />{" "}
                        <span>Project & Performance​</span>
                      </li>

                      <li>
                        <LiaCheckDoubleSolid color="green" size={20} />{" "}
                        <span>Leave Management</span>
                      </li>
                      <li>
                        <LiaCheckDoubleSolid color="green" size={20} />{" "}
                        <span>Resources</span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 order-1 order-lg-2 text-center">
                    <img
                      src={FeatureImg}
                      alt="FeatureImg"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
              {/* <div className="tab-pane fade" id="features-tab-2">
            <div className="row">
              <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                <h3>Neque exercitationem debitis</h3>
                <p className="fst-italic">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                  magna aliqua.
                </p>
                <ul>
                  <li><i className="bi bi-check2-all"></i> <span>Ullamco laboris nisi ut aliquip ex ea commodo consequat.</span></li>
                  <li><i className="bi bi-check2-all"></i> <span>Duis aute irure dolor in reprehenderit in voluptate velit.</span></li>
                  <li><i className="bi bi-check2-all"></i> <span>Provident mollitia neque rerum asperiores dolores quos qui a. Ipsum neque dolor voluptate nisi sed.</span></li>
                  <li><i className="bi bi-check2-all"></i> <span>Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</span></li>
                </ul>
              </div>
              <div className="col-lg-6 order-1 order-lg-2 text-center">
                <img src="assets/img/features-illustration-2.webp" alt="" className="img-fluid" />
              </div>
            </div>
          </div>

          <div className="tab-pane fade" id="features-tab-3">
            <div className="row">
              <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                <h3>Voluptatibus commodi accusamu</h3>
                <ul>
                  <li><i className="bi bi-check2-all"></i> <span>Ullamco laboris nisi ut aliquip ex ea commodo consequat.</span></li>
                  <li><i className="bi bi-check2-all"></i> <span>Duis aute irure dolor in reprehenderit in voluptate velit.</span></li>
                  <li><i className="bi bi-check2-all"></i> <span>Provident mollitia neque rerum asperiores dolores quos qui a. Ipsum neque dolor voluptate nisi sed.</span></li>
                </ul>
                <p className="fst-italic">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                  magna aliqua.
                </p>
              </div>
              <div className="col-lg-6 order-1 order-lg-2 text-center">
                <img src="assets/img/features-illustration-3.webp" alt="featuresImage"  className="img-fluid" />
              </div>
            </div>
          </div> */}
            </div>
          </div>
        </section>

          {/* Call to Action */}

          <section
          id="call-to-action-2"
          className="call-to-action-2 section dark-background"
        >
          <div className="container">
            <div
              className="row justify-content-center"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="col-xl-10">
                <div className="text-center">
                  <h3>Empower Your Workforce with refo</h3>
                  <p>
                  Ready to elevate your HR and recruitment process? Discover how refo can transform your organization with its intuitive features and powerful integrations. Don’t wait—streamline your operations today!
                  </p>
                 
                  <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  style={{cursor:"pointer"}}
                  offset={-120}
                  duration={500}

                  className="cta-btn"
                >
                    Call To Action
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

      

        {/* ATS Cards */}

        <section id="features-cards" className="features-cards section">
          <div className="container">
            <div className="row gy-4">
              <div
                className="col-xl-4 col-md-6"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div className="feature-box orange text-center">
                  <IoShieldCheckmarkOutline
                    size={44}
                    color="#edb86e"
                    className="mb-3"
                  />
                  <h4>Top Tier pre-vetted, pre-qualified job requirements</h4>
                </div>
              </div>

              <div
                className="col-xl-4 col-md-6"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <div className="feature-box green  text-center">
                  <TfiStatsUp size={44} color="#48c88a" className="mb-3" />
                  <h4>Integrated Hi-End ATS(Applicant Tracking System)</h4>
                </div>
              </div>

              <div
                className="col-xl-4 col-md-6"
                data-aos="zoom-in"
                data-aos-delay="400"
              >
                <div className="feature-box red  text-center">
                  <RiPassValidLine size={44} color="#f28484" className="mb-3" />
                  <h4>
                    Upcoming AI integration for candidate validation &
                    engagement
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ATS Content  */}

        <section id="ats" className="ats-sec section">
          {/* <div className="container section-title" data-aos="fade-up">
            <h2>Addional Features</h2>
          </div> */}

          <div className="container">
            <div className="row">
              <div className="col-lg-6 order-1 order-lg-1 text-center">
                <img
                  src={refoDashboard}
                  alt="FeatureImg"
                  className="img-fluid rounded"
                  style={{
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                />
              </div>
              <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                <h3>Redefining ATS with Next-Gen Technology</h3>
                <p className="fst-italic">
                refo isn’t just an ATS—it’s a complete solution for smarter hiring, better management, and informed decision-making. With innovative tools and seamless integrations, it helps streamline the hiring process and enhances collaboration within your team. From real-time updates to customizable features, refo empowers you to manage your recruitment pipeline with greater efficiency and control. Experience a flexible platform that adapts to your unique hiring needs and drives better outcomes.
                </p>
              </div>
            </div>
          </div>
        </section>

      

        {/* Contact */}

        <section id="contact" className="contact section light-background">
          <div className="container section-title" data-aos="fade-up">
            <h2>Contact</h2>
  
          </div>

          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row g-4 g-lg-5">
              <div className="col-lg-5">
                <div
                  className="info-box"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <h3>Contact Info</h3>
              

                 
                  <div
                    className="info-item"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <div className="icon-box">
                      <FiPhone className="text-light" size={28} />
                    </div>
                    <div className="content">
                      <h4>Phone Number</h4>
                      <p>+91 9025992817</p>
                      
                    </div>
                  </div>

                  <div
                    className="info-item"
                    data-aos="fade-up"
                    data-aos-delay="500"
                  >
                    <div className="icon-box">
                      <IoMailOutline className="text-light" size={28} />
                    </div>
                    <div className="content">
                      <h4>Email Address</h4>
                      <p>info@example.com</p>
                   
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-7">
                <div
                  className="contact-form"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <h3>Get In Touch</h3>
                

                  <form
                    onSubmit={handleSubmit(handleDemoSubmit,(e)=> console.log(e))}
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <div className="row gy-4">
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Your Name"
                          {...register("companyName")}
                        />
                        <div className="text-danger ">
                          {errors?.companyName?.message}
                        </div>
                      </div>

                      <div className="col-md-6 ">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Your Email"
                          {...register("email")}
                        />
                        <div className="text-danger ">
                          {errors?.email?.message}
                        </div>
                      </div>

                      <div className="col-12">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Phone Number"
                          {...register("mobile")}
                        />
                        <div className="text-danger ">
                          {errors?.mobile?.message}
                        </div>
                      </div>

                      <div className="col-12">
                        <textarea
                          className="form-control"
                          rows={6}
                          placeholder="Message"
                          {...register("message")}
                        ></textarea>
                        <div className="text-danger ">
                          {errors?.message?.message}
                        </div>
                      </div>

                      <div className="col-12 text-center">
                        {/* <div className="loading">Loading</div>
                        <div className="error-message"></div>
                        <div className="sent-message">
                          Your message has been sent. Thank you!
                        </div> */}

                        <button type="submit" className="btn">
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer id="footer" className="footer">
  

        <div className="container copyright text-center mt-4">
          <p>
            © <span>Copyright</span> <strong className="px-1 sitename"></strong>{" "}
            <span>All Rights Reserved</span>
          </p>
        </div>
      </footer>

      <ToastContainer
          closeButton={
            <IoCloseSharp className="text-light mt-3 me-3" size={18} />
          }
          closeOnClick={false}
          hideProgressBar={true}
        />
    </>
  );
};

export default HomePage;
